import { render, staticRenderFns } from "./OpinionAnalysisManager.vue?vue&type=template&id=41e06f38"
import script from "./OpinionAnalysisManager.vue?vue&type=script&lang=js"
export * from "./OpinionAnalysisManager.vue?vue&type=script&lang=js"
import style0 from "./OpinionAnalysisManager.vue?vue&type=style&index=0&id=41e06f38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports